import "./NoListProv.css";

const NoListProv = ({ title, Icon }) => {
  /*Los props van en Titulo y Icono*/
  return (
    <div className="boxnotdatalistprovlealtad">
      <div>
        <Icon className="Nolistprovlistlealtad" />
      </div>
      <div className="boxtittlelisprovlealtad">
        <p className="tittlenotdatalistprovlealtad">{title}</p>
      </div>
      <div className="boxexplainnotdatalistprovlealtad">
        <p className="explainotdatalistprovlealtad">
          Tus ventas aún no han sido cargadas.
        </p>
      </div>
    </div>
  );
};

export default NoListProv;
